import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Settings as SettingsIcon, Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { useUserRole } from "@/hooks/useUserRole";
import { PlatformOwnerSettings } from "@/components/settings/PlatformOwnerSettings";
import { OrgAdminSettings } from "@/components/settings/OrgAdminSettings";

export default function Settings() {
  const { user, loading: authLoading } = useAuth();
  const { isPlatformOwner, loading: roleLoading } = useUserRole();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && !user) {
      navigate("/auth");
    }
  }, [user, authLoading, navigate]);

  if (authLoading || roleLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-6xl mx-auto p-6 space-y-6">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <SettingsIcon className="w-8 h-8" />
            <h1 className="text-3xl font-bold">Settings</h1>
          </div>
          <p className="text-muted-foreground">
            {isPlatformOwner
              ? "Manage platform-wide settings and configurations"
              : "Manage your organization and account settings"}
          </p>
        </div>

        {isPlatformOwner ? <PlatformOwnerSettings /> : <OrgAdminSettings />}
      </div>
    </div>
  );
}
